import NotiSetting from "../components/NotiSetting";
import SettingNotiEmil from "../components/SettingNotiEmil";


function SettingPage() {
  return <NotiSetting />;
}

export default SettingPage;
